import React from 'react'
import { StarSVG, StarStrokeSVG } from '../../SVG'

function ReviewPage() {
  return (
    <>
      <section className="flat-title2 ">
        <div className="container7">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-group fs-30 lh-45 fw-7">Tous les avis (3)</div>
            </div>
          </div>
        </div>
      </section>
      <section className="flat-dashboard flat-all-review">
        <div className="container7">
          <div className="row">
            <div className="col-lg-12">
              <div className="tf-reviews">
                <div className="reviews-sidebar messages-sidebar bg-white">
                  <ul>
                    <Review />
                    <Review />
                    <Review />
                  
                  </ul>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </section>
    </>

  )
}

export const Review = () => <li>
  <div className="image-box flex align-center">
    <div className="images">
      <img
        src="/assets/images/author/author-list-3.jpg"
        alt="images"
      />
    </div>
    <div className="title-flat fw-6">Bessie Cooper</div>
    <p className="fs-12 lh-18">Il y a 3 jours</p>
  </div>
  <div className="content">
    <p className="text-color-2">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
      Vivamus viverra semper convallis. Integer vestibulum
      tempus tincidunt.
    </p>
    <div className="star flex">
      <StarSVG />
      <StarSVG />
      <StarSVG />
      <StarSVG />
      <StarStrokeSVG />
    </div>
  </div>
</li>

export default ReviewPage